import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import Select, { ActionMeta, Styles, ValueType } from 'react-select';
// tslint:disable-next-line: no-submodule-imports
import { Props } from 'react-select/src/Select';
import { Button } from 'reactstrap';
import './MultiSelect.scss';

class MultiSelect extends React.Component<Props & LocalizeContextProps> {
    public render() {
        const t = this.props.translate;
        // tslint:disable-next-line: no-any
        let options: any[] = this.props.options as any[];

        // tslint:disable-next-line: no-any
        const canSelectAll = (this.props.value as any[] || []).length < options.length;
        // tslint:disable-next-line: no-any
        const canDeselectAll =  (this.props.value as any[] || []).length > 0;

        if (canDeselectAll) {
            options = [{ label: t('modal.deselectAll') as string, value: '@@DESELECT_ALL' }, ...options];
        }

        if (canSelectAll) {
            options = [{ label: t('modal.selectAll') as string, value: '@@SELECT_ALL' }, ...options];
        }

        const customStyles = {
            // tslint:disable-next-line: no-any
            option: (provided: any, state: any) => {
                const special = (state.data.value === '@@SELECT_ALL' || state.data.value === '@@DESELECT_ALL');
                return {
                    ...provided,
                    display: special ? 'inline-block' : provided.display,
                    width: special && canSelectAll && canDeselectAll ? '50%' : provided.width,
                    backgroundColor: (special && !state.isFocused) ?
                        '#fefefe' : provided.backgroundColor,
                    borderBottom: special ? '1px solid #ddd' : provided.borderBottom,
                    fontWeight: special ? 'bold' : provided.borderBottom,
                };
            },
        };

        return (
            <div className={"multi-select"}>
                <Select className={"react-select-dropdown dropdown-select"}
                    {...this.props}
                    isMulti={true}
                    options={options}
                    onChange={this.onChange}
                    styles={customStyles}
                />
            </div>
        );
    }

    private onChange = (val: ValueType<{ label: string, value: string }>, meta: ActionMeta) => {
        if (this.props.onChange) {
            // tslint:disable-next-line: no-any
            if ((val as any[] || []).find((v) => v.value === '@@SELECT_ALL') !== undefined) {
                // tslint:disable-next-line: no-any
                this.props.onChange(this.props.options as any, meta);
                // tslint:disable-next-line: no-any
            } else if ((val as any[] || []).find((v) => v.value === '@@DESELECT_ALL') !== undefined) {
                this.props.onChange([], meta);
            } else {
                this.props.onChange(val, meta);
            }
        }
    }
}

export default withLocalize(MultiSelect);